__turbopack_context__.v({
  "root": "StringFormatter-module__O8wbpa__root",
});
